import * as ae_theme_0 from 'theme/assets/js/main.js';
ae_theme_0.run();
